import type { VariantProps } from '@gluestack-ui/utils/nativewind-utils'
import React from 'react'
import { cn } from '@/lib/cn'
import { textStyle } from './styles'

type ITextProps = React.ComponentProps<'span'> & VariantProps<typeof textStyle>

const Text = React.forwardRef<React.ComponentRef<'span'>, ITextProps & { numberOfLines?: number }>(function Text(
  { className, isTruncated, bold, underline, strikeThrough, size = 'body', sub, italic, highlight, numberOfLines: _numberOfLines, ...props },
  ref
) {
  // 不把 className 传给 tva，避免 tva 内置的 twMerge 错误合并
  const variantClassName = textStyle({ isTruncated, bold, underline, strikeThrough, size, sub, italic, highlight } as NonNullable<Parameters<typeof textStyle>[0]>)

  // 使用自定义的 cn 函数合并：
  // - text-label 作为默认颜色，放在最前面，可被用户传入的颜色类覆盖
  // - text-body + text-xl → 只保留 text-xl（都是 fontSize，后者覆盖）
  const finalClassName = cn('text-label', variantClassName, className)

  return <span className={finalClassName} {...props} ref={ref} />
})

Text.displayName = 'Text'

export { Text }
